export const formatYYMMDD = (date) => {
	let d = new Date(date)
	d.setMinutes(d.getMinutes() + d.getTimezoneOffset())
	return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2)
}

export const formatDDMMYY = (date) => {
	let d = new Date(date)
	d.setMinutes(d.getMinutes() + d.getTimezoneOffset())
	return ('0' + d.getDate()).slice(-2) + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + d.getFullYear()
}

export const formatMMDDYY = (date) => {
	let d = new Date(date)
	d.setMinutes(d.getMinutes() + d.getTimezoneOffset())
	return ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2) + '-' + d.getFullYear()
}

export const getDateTimeNow = () => {
	const now = new Date();
  
	const day = now.getDate().toLocaleString().padStart(2, '00');
	const month = (now.getMonth() + 1).toLocaleString().padStart(2, '00');
	const year= now.getFullYear();
	const hour = now.getHours().toLocaleString().padStart(2, '00');
	const minutes = now.getMinutes().toLocaleString().padStart(2, '00');
	const seconds = now.getSeconds().toLocaleString().padStart(2, '00');
	const milliseconds = now.getMilliseconds().toLocaleString().padStart(2, '00');
  
	return day + month + year + hour + minutes + seconds + milliseconds;
};

export default {
	formatYYMMDD,
	formatDDMMYY,
	formatMMDDYY,
	getDateTimeNow
}
